import './index.scss';
import './styles/main.scss'
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import ConfigProvider from 'config/ConfigProvider';
import Provider from 'state/Provider';
import Store from 'state/Store';
import ErrorBoundary from 'components/layouts/Error/ErrorPage/ErrorBoundary'

ReactDOM.render(
  <ConfigProvider>
    <Provider store={Store}>
      <ErrorBoundary>
        <App/>
      </ErrorBoundary>
    </Provider>
  </ConfigProvider>, document.getElementById('root')
);
